import { DataSpecificationSchema, } from "@dataspecer/core/data-specification/model";
import { assertFailed, assertNot } from "@dataspecer/core/core";
import { transformStructureModel, structureModelAddDefaultValues } from "@dataspecer/core/structure-model/transformation";
import { ShaclAdapter } from "./shacl-adapter.js";
import { DataSpecificationConfigurator, DefaultDataSpecificationConfiguration } from "@dataspecer/core/data-specification/configuration";
import { clone } from "@dataspecer/core/core";
export class ShaclGenerator {
    static IDENTIFIER = "https://schemas.dataspecer.com/generator/shacl";
    identifier() {
        return ShaclGenerator.IDENTIFIER;
    }
    generateForDocumentation() {
        return Promise.resolve(null); // Null means no documentation is necessary
        //throw new Error("Method not implemented.");
    }
    async generateToObject(context, artefact, specification) {
        if (!DataSpecificationSchema.is(artefact)) {
            assertFailed("Invalid artefact type.");
        }
        const schemaArtefact = artefact;
        const conceptualModel = context.conceptualModels[specification.pim];
        assertNot(conceptualModel === undefined, `Missing conceptual model ${specification.pim}.`);
        let model = context.structureModels[schemaArtefact.psm];
        assertNot(model === undefined, `Missing structure model ${schemaArtefact.psm}.`);
        const globalConfiguration = DataSpecificationConfigurator.merge(DefaultDataSpecificationConfiguration, DataSpecificationConfigurator.getFromObject(schemaArtefact.configuration));
        model = Object.values(context.conceptualModels).reduce((model, conceptualModel) => transformStructureModel(conceptualModel, model, Object.values(context.specifications)), model);
        model = structureModelAddDefaultValues(model, globalConfiguration);
        artefact.configuration["publicBaseUrl"] = globalConfiguration.publicBaseUrl;
        const adapter = new ShaclAdapter(model, context, artefact);
        return adapter.generate();
    }
    async generateToStream(context, artefact, specification, output) {
        const model = await this.generateToObject(context, artefact, specification);
        const stream = output.writePath(artefact.outputPath);
        await stream.write(model.data);
        await stream.close();
    }
    structureModelAddDefaultValues(structure, configuration) {
        const result = clone(structure);
        const classes = result.getClasses();
        for (const classData of classes) {
            classData.instancesHaveIdentity ??= configuration.instancesHaveIdentity;
            classData.instancesSpecifyTypes ??= configuration.instancesSpecifyTypes;
            classData.isClosed ??= configuration.dataPsmIsClosed == "CLOSED";
        }
        return result;
    }
}
//# sourceMappingURL=shacl-generator.js.map